import { cn } from '@verlo/shared/lib/utils';

/**
 * The one empty state (Back Office Review, wave A): a word, a line, one action. Never a
 * grey illustration; never "No data". The word is what's absent — Orders, Deliveries — and
 * the line says what to do about it.
 *
 *   <Empty word="Deliveries" title="Nothing booked in yet" action={<Button>Book a delivery</Button>}>
 *     What arrives gets checked against what was ordered, here.
 *   </Empty>
 */
const Empty = ({ word, title, children, action, className, testId }) => (
  <div className={cn('flex flex-col items-center justify-center rounded-lg border border-dashed border-hairline bg-surface-2 px-6 py-10 text-center', className)} data-testid={testId}>
    {word && <div className="font-heading text-[11px] font-bold uppercase tracking-[0.08em] text-ink-faint">{word}</div>}
    <div className="mt-1 font-heading text-[15px] font-bold text-ink">{title}</div>
    {children && <p className="mt-1 max-w-md text-[13.5px] text-ink-soft">{children}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export default Empty;
